module.exports = __webpack_public_path__ + "img/image_3.fea95d76.jpg";